<template>
  <v-container fluid style="padding-left: 300px">
    <h1>マスターユーザー編集</h1>
    <v-row>
      <v-col cols="12">
        <v-form>
          <v-card elevation="0" tile outlined>
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-left">名前</th>
                  <th class="text-left">登録メールアドレス</th>
                  <th class="text-left">支払いエンティティ</th>
                  <th class="text-left">支払い名</th>
                  <th class="text-left">海外在住か否か</th>
                  <th></th>
                </tr>
              </thead>
              <tr>
                <td class="text-center">{{ userAuthQuery.id }}</td>
                <td>{{ userAuthQuery.name }}</td>
                <td>{{ userAuthQuery.email }}</td>
                <td>
                  <v-select
                    v-model="userAuthQuery.paymentEntity"
                    :items="selectablePaymentEntity"
                    item-text="type"
                    style="max-width: 160px"
                    class="ma-2"
                    item-value="value"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="userAuthQuery.paymentName"
                    style="max-width: 150px"
                    clearable
                    class="ma-2"
                  />
                </td>
                <td>
                  <v-select
                    v-model="userAuthQuery.livingAbroad"
                    :items="selectableLivingAbroad"
                    item-text="type"
                    style="max-width: 200px"
                    class="ma-2"
                    item-value="value"
                  />
                </td>
                <td>
                  <v-btn
                    color="primary"
                    dark
                    tile
                    outlined
                    class="ma-2"
                    @click="updateUserAuth"
                  >
                    変更
                  </v-btn>
                </td>
              </tr>
            </v-simple-table>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'UserAuthEdit',
  data: () => {
    return {
      userAuthQuery: [],
      selectablePaymentEntity: [
        { type: '未選択', value: null },
        { type: '直接', value: 'direct' },
        { type: 'CW クラフタ', value: 'cw_crafta' },
        { type: 'CW 1k', value: 'cw_1k' },
        { type: 'CW 暮らしの', value: 'cw_kurashino' }
      ],
      selectableLivingAbroad: [
        { type: '海外在住', value: true },
        { type: '海外在住ではない', value: false }
      ]
    }
  },
  mounted: function () {
    axios.get(`/api/master/user_auths/${this.$route.params.id}`).then(
      ({ data }) => {
        this.userAuthQuery = deserialize(data.data).attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    updateUserAuth () {
      axios
        .patch(
          `/api/master/user_auths/${this.$route.params.id}`,
          this.userAuthQuery
        )
        .then(
          () => {
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
